module.exports = __webpack_public_path__ + "img/gabriela-perez-del-solar.40e2304f.png";